import { Component, Input, Output, EventEmitter, ViewChild, forwardRef } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgIf } from '@angular/common';
import './html-embed-blot';

@Component({
  selector: 'vex-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  standalone: true,
  imports: [QuillEditorComponent, FormsModule, NgIf],
  styleUrls: ['./rich-text-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichTextEditorComponent),
      multi: true
    }
  ]

})
export class RichTextEditorComponent {
  @Input() content: string = '';
  @Output() contentChange = new EventEmitter<string>();

  @ViewChild(QuillEditorComponent) quill!: QuillEditorComponent;

  isCodeView = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  writeValue(value: any): void {
    // When form sets initial value (optional)
    if (!value) return;
    this.contentChange.emit(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: Disable UI
  }

  modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['link', 'image', 'video'],
        ['clean'],
        ['embed'] // 👈 NEW BUTTON
      ],
      handlers: {
        embed: () => this.insertEmbedCode()
      }
    }
  };

  insertEmbedCode() {
    const embedHtml = prompt('Paste your iframe / embed HTML:');
    if (!embedHtml) return;

    const editor = this.quill.quillEditor;
    if (!editor) {
      console.error('Editor still not ready');
      return;
    }

    const range = editor.getSelection(true);
    editor.clipboard.dangerouslyPasteHTML(range.index, embedHtml);
  }


  onContentChanged(event: any) {
    this.onChange(event.html)
    this.contentChange.emit(event.html);
  }

  toggleCodeView() {
    this.isCodeView = !this.isCodeView;
  }
}
